<template>
  <div>
    <Title :title="'司机新增及活跃趋势'"></Title>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from '../chart.vue';
import Title from '../../title';
import { indexLeft } from '@/api/indexLeft';
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      userAddCurrentList:[],//新增用户
      userActivityCurrentList:[],//活跃度
      cdata: {
        category: [],
        rateData: [],
        id:"userAddChart",
        legendData:[{
              name:"新增用户",
              icon: 'roundRect',
            }, {
              name:"活跃度",
              icon: 'roundRect',
        }],
        series:[
            {
              name: "新增用户",
              type: "line",
              smooth: true,
              // showAllSymbol: true,
              // symbol: "emptyCircle",
              symbolSize: 1,
              // yAxisIndex: 1,
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#36A1FF" },
                    { offset: 1, color: "#1968FF" }
                ])
              },
              data:this.userAddCurrentList
            },
            {
              name: "活跃度",
              type: "line",
              smooth: true,
              // showAllSymbol: true,
              // symbol: "emptyCircle",
              symbolSize: 1,
              // yAxisIndex: 1,
              itemStyle: {
                normal: {
                  color: "#90F3FF"
                }
              },
              data: this.userActivityCurrentList
            },
        ]
      }
    };
  },
  components: {
    Chart,
    Title,
  },
  mounted () {
    
  },
  methods: {
    getData(data){
      this.selectUserAddActivityCurrent(data);
    },
    selectUserAddActivityCurrent(data={}){
      let _this = this;
      const { query } = this.$route
      if(query.token) localStorage.setItem('uid',query.token )
      let params = {
        enCode: "hdz-yhhyqs",
        "@province": data.province || data.city || data.district || "000000",
        '@uid': localStorage.getItem('uid') || '000000'
      };
      dataInterface
        .dataFaceApiXZ(params)
        .then((res) => {
          console.log(res, 'hdz-yhhyqs')
          if(!res) return;
          let MonthlyActiveUsers = [];
          let NewUsers = [];
          let xList = [];
          res.forEach(item=>{
            MonthlyActiveUsers.push(item.hyyh);
            NewUsers.push(item.xzrw);
            xList.push(item.mon);
          })
          this.cdata.series[0].data = NewUsers;//新增用户
          this.cdata.series[1].data = MonthlyActiveUsers;//活跃度
          this.cdata.category = xList;
        })
        .catch((err) => {
          console.log(err);
        });
    }, 
  }
};
</script>

<style lang="scss" scoped>
</style>